export function formatHackathonDate(date: Date): string {
  const formattedDate = date
    .toLocaleString('en-US', {
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZone: 'America/Los_Angeles',
      hour12: true,
    })
    .replace(',', ' at');

  const timeZone = date
    .toLocaleTimeString('en-US', {
      timeZone: 'America/Los_Angeles',
      timeZoneName: 'short',
    })
    .split(' ')
    .pop();

  return `${formattedDate} ${timeZone}`;
}
